import React from 'react';
import styled, { css } from 'styled-components';
import { Arrow } from '../Icons';
import { theme } from '../../styled';
import { getSanitizedText } from '../../helpers/sanitizeHtml';
export const ReadMoreWrapper = styled.div `
  font-size: ${(props) => props.theme.fontXXSmall};
  word-break: break-word;
`;
export const FullText = styled.p `
  margin: 0;
`;
const ArrowWrapper = css `
  display: block;
  margin-top: 0.3125rem;
  margin-bottom: 0;
  cursor: pointer;
  font-size: ${(props) => props.theme.fontXXSmall};
`;
export const ShowMoreWrapper = styled.p `
  ${ArrowWrapper};
  color: ${(props) => props.theme.blue};

  .arrow-more {
    transform: rotate(90deg);
    transform-origin: 30% 50% 0;
    margin-left: 0.5rem;
  }
`;
export const ShowLessWrapper = styled.p `
  ${ArrowWrapper};
  color: ${(props) => props.theme.blue};

  .arrow-less {
    transform: rotate(270deg);
    transform-origin: 60% 50% 0;
    margin-left: 0.75rem;
  }
`;
class ReadMore extends React.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            const paragraphMaxHeight = 40;
            if (this.textRef.current &&
                paragraphMaxHeight >= this.textRef.current.scrollHeight) {
                this.setState({
                    truncated: false,
                });
            }
            else {
                this.setState({
                    truncated: true,
                });
            }
        };
        this.toggle = () => {
            this.setState({
                expanded: !this.state.expanded,
            });
        };
        this.textRef = React.createRef();
        this.state = {
            expanded: false,
            truncated: false,
        };
    }
    render() {
        const { text, showMoreText, showLessText } = this.props;
        const { expanded, truncated } = this.state;
        const canShowArrowMore = truncated && !expanded && showMoreText;
        const canShowArrowLess = expanded && showLessText;
        return (React.createElement(ReadMoreWrapper, null,
            React.createElement(FullText, { style: expanded
                    ? { height: 'auto' }
                    : { height: '30px', overflow: 'hidden' }, ref: this.textRef },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: getSanitizedText(text) } })),
            canShowArrowMore && (React.createElement(ShowMoreWrapper, { onClick: this.toggle },
                showMoreText,
                " ",
                React.createElement(Arrow, { className: "arrow-more", color: theme.blue }))),
            canShowArrowLess && (React.createElement(ShowLessWrapper, { onClick: this.toggle },
                showLessText,
                React.createElement(Arrow, { className: "arrow-less", color: theme.blue })))));
    }
}
export default ReadMore;
